export default "__VITE_ASSET__CL0uMTiU__"